import magicIcon from "@loot-os/icons/icons/magic";
import { Alert } from "../../../../core/Alert.js";
import { Text } from "../../../../core/Text.js";
import { cn } from "../../../../foundations/cn.js";
import { RichTextView } from "../../../home/sections/faq/HomeFaq.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import type { BoxPageOpenerContent } from "../../boxPageContent.js";

export interface BoxPageOpenerProps extends BoxPageOpenerContent {
  className?: string;
}

/**
 * Where the box opens: the app's opener in its slot, with the demo notice above it when the
 * shopper is signed out, why the last open was refused, and a line under it.
 */
export function BoxPageOpener({ slot, demo, error, footnote, className }: BoxPageOpenerProps) {
  return (
    <div className={cn("flex w-full min-w-0 flex-col gap-4", className)}>
      {demo && (
        <Alert
          tone="accent"
          icon={magicIcon}
          announce={false}
          action={
            <ActionButton
              action={demo.action}
              variant={demo.action.emphasis === "primary" ? "brand" : "secondary"}
              size="sm"
            />
          }
        >
          {demo.message}
        </Alert>
      )}
      {error && <Alert tone="danger">{error}</Alert>}
      <div className="min-w-0">{slot}</div>
      {footnote && (
        <Text as="p" variant="body-b3" tone="tertiary">
          <RichTextView text={footnote} />
        </Text>
      )}
    </div>
  );
}
